import React, { useState } from 'react';
import Button from 'components/atoms/Button/Button';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import FilterSwitchCard from 'components/molecules/FilterSwitchCard/FilterSwitchCard';
import { FILTERS } from 'components/organisms/SurveyList/Surveys';
import classes from './SurveyFiltersModal.module.scss';
import clsx from 'clsx';

export type Props = {
  onSaveFilters: (filters: string[]) => void;
  filters: string[];
  className?: string;
};

export default function SurveysFilterModal({ filters, onSaveFilters, className }: Props) {
  const [checkedFilters, setCheckedFilters] = useState(filters);

  const handleFilterChange = (filter: string) => {
    if (checkedFilters.includes(filter)) {
      setCheckedFilters(checkedFilters.filter((f) => f !== filter));
    } else {
      setCheckedFilters([...checkedFilters, filter]);
    }
  };

  return (
    <dialog className={classes.root} aria-label="Survey filters" open>
      <div className={clsx(classes.content, className)}>
        <Heading level={2} className={classes.heading}>
          Survey Filters
        </Heading>
        <div className={classes.filtersContainer}>
          {Object.entries(FILTERS).map(([key, filter]) => (
            <FilterSwitchCard
              key={key}
              icon={filter.icon}
              title={`${filter.title} Surveys`}
              description={filter.description}
              onHandleToggle={() => handleFilterChange(key)}
              isActive={checkedFilters?.includes(key) ?? false}
            />
          ))}
        </div>
        <Button
          className={classes.actionButtons}
          buttonType="primary"
          buttonSize="large"
          onClick={() => onSaveFilters(checkedFilters)}
        >
          <Txt>Done</Txt>
        </Button>
      </div>
    </dialog>
  );
}
